import { render, staticRenderFns } from "./UpdateUserPhone.vue?vue&type=template&id=6a500641&scoped=true"
import script from "./UpdateUserPhone.vue?vue&type=script&lang=js"
export * from "./UpdateUserPhone.vue?vue&type=script&lang=js"
import style0 from "./UpdateUserPhone.vue?vue&type=style&index=0&id=6a500641&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a500641",
  null
  
)

export default component.exports